"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const SectionHeader_1 = require("./SectionHeader");
exports.cardHeaderHeight = 36;
const Container = styled_1.default(SectionHeader_1.SectionHeader)(({ theme }) => ({
    borderBottom: `1px solid ${theme.color.separators.default}`,
    height: exports.cardHeaderHeight,
    "& > :not(:first-of-type)": {
        fontSize: theme.font.size.fineprint,
        color: theme.color.text.lightest,
    },
    /**
     * Use case: External Links typically have <Icon/>s next to them.
     */
    "& a": {
        display: "inline-flex",
        alignItems: "center",
        textDecoration: "none",
    },
}));
const ActionsContainer = styled_1.default("div") `
  display: flex;
  align-items: center;
  > :last-child {
    margin-right: 0;
  }
`;
const CardHeader = (_a) => {
    var { title, children, action } = _a, props = __rest(_a, ["title", "children", "action"]);
    return (React.createElement(Container, Object.assign({}, props),
        React.createElement("div", null, title || children),
        React.createElement(ActionsContainer, null, action)));
};
exports.default = CardHeader;
//# sourceMappingURL=CardHeader.js.map